import { useLeagueToggle } from "../../../../hooks/useLeagueToggle.js";
import SecondaryTitle from "../reusablesComponent/subtitle.js";
import PeriodTitle from "../reusablesComponent/periodTitle.js";
import FooterCard from "../reusablesComponent/footerCard.js";
import { handleClickCard, getBettingData, getGameStates, getLeagueContainer, getGridClass } from "../../../../functions/functions.js";
import ScoreTenislComponent from "./scoreTenis.js";
import MomiosTenisComponent from "./momiosTenis.js";
import Player from "../reusablesComponent/player.js";
import BotonApostarHub from "../reusablesComponent/buttonApostar.js";

/**
 * Componente especializado para mostrar tarjetas de eventos de tenis
 * Renderiza partidos con información específica del tenis: sets, games, momios
 * Incluye funcionalidad de ligas colapsables y soporte para múltiples casas de apuestas
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.leagues - Array de ligas/torneos de tenis con sus partidos
 * @param {boolean} props.mostrarMomios - Controla la visibilidad de los momios de apuestas
 * @param {Array} props.flags - Array de códigos de países disponibles para banderas
 * @param {boolean} props.mostrarBotonApostar - Controla la visibilidad del botón de apuestas
 * @param {boolean} props.ocultarApostarTenis - Flag específico para ocultar apuestas en tenis
 * @param {boolean} props.isStrendus - Determina qué casa de apuestas usar (Strendus vs Caliente)
 * 
 * @returns {JSX.Element} Componente con tarjetas de partidos de tenis
 */
export default function CardTenis({
  leagues,
  mostrarMomios,
  flags,
  mostrarBotonApostar,
  ocultarApostarTenis,
  isStrendus,
  isTenis
}) {

  // Hook para manejar el estado de expansión/colapso de ligas
  const { openMap } = useLeagueToggle(leagues);

  return (
    <>
      {leagues.map((league, indexLeague) => {
        const { contId, id, visible, key } = getLeagueContainer(league, indexLeague, openMap);

        return (
          <div key={key} className={`${getGridClass(league.games?.length)}`}>
            {/* Título de la liga con funcionalidad de toggle */}
            <SecondaryTitle
              leagueName={league.name}
              isVisible={visible}
              linkLiga={league.url}
              leagueImage={league.image}
            />

            {/* Contenedor de partidos de la liga */}
            <div
              id={contId}
              className="content-list-cards content-f1-tenis"
              style={{ display: "grid" }}
            >
              {league.games.map((item, gameIdx) => {
                // Funciones utilitarias para extraer lógica repetida
                const { time_format, isNextOrError, isFinished, isError } = getGameStates(item);
                const { hasMm, apostarHref } = getBettingData(item, isStrendus);

                // Destructuring para datos específicos del tenis
                const {
                  opta_event_url,
                  utc_date,
                  period_title,
                  venue_country,
                  venue_name,
                  venue_state,
                  right_class,
                  right_image,
                  left_class,
                  left_image,
                  left_name,
                  right_name,
                  tenis_data
                } = item;

                // Lógica específica del tenis
                const showCenterBlock = !isNextOrError && !isFinished;
                const centerClass = isNextOrError ? "card-body-center-none" : "card-body-center";
                const shouldShowButton = mostrarBotonApostar === 'true' && !isFinished && !isError && !ocultarApostarTenis;

                return (
                  <div key={gameIdx} className="card-complete-event cursorAuto card-complete-tenis">
                    <div className="card-game cursorAuto">

                      {/* BODY - Contenido principal del partido */}
                      <div className="card-body cursorAuto">

                        {/* SECCIÓN IZQUIERDA - Jugadores*/}
                        <div className="card-body-left cursorAuto" style={{ "width": '50%' }}>
                          {/* Jugador 1 */}
                          <Player
                            type="tennis"
                            imagen={left_image}
                            name={left_name}
                            seed={tenis_data?.left_stats?.left_seed}
                            flags={flags}
                          />

                          {/* Jugador 2 */}
                          <Player
                            type="tennis"
                            imagen={right_image}
                            name={right_name}
                            seed={tenis_data?.right_stats?.right_seed}
                            flags={flags}
                          />
                        </div>

                        {/* HEADER - Estado del partido y botón de apuestas */}
                        <PeriodTitle
                          clase={item.class}
                          opta_event_url={opta_event_url}
                          period_title={period_title}
                          utc_date={utc_date}
                          time_format={time_format}
                          isTenis={isTenis}
                          tenis_fase={tenis_data?.tenis_fase}
                        />

                        {/* SECCIÓN DERECHA - Puntajes (solo si no es próximo partido o error) */}
                        {!isNextOrError && (
                          <ScoreTenislComponent
                            showCenterBlock={showCenterBlock}
                            item={item}
                            isFinished={isFinished}
                            rightIsWinner={String(right_class).toLowerCase() === "clarosports-winner"}
                            leftIsWinner={String(left_class).toLowerCase() === "clarosports-winner"}
                          />
                        )}

                        {/* SECCIÓN MOMIOS - Solo si están habilitados y hay datos válidos */}
                        {hasMm && mostrarMomios === true && (
                          <MomiosTenisComponent
                            item={item}
                            handleClickCard={handleClickCard}
                            centerClass={centerClass}
                            isStrendus={isStrendus}
                          />
                        )}
                      </div>

                      {shouldShowButton && !isTenis  &&
                        <BotonApostarHub
                          mostrarBotonApostarCard={shouldShowButton}
                          isStrendus={isStrendus}
                          apostarHref={apostarHref}
                        />
                      }

                      {/* FOOTER - Información del venue */}
                      <FooterCard
                        estadio={venue_name}
                        ciudad={venue_state}
                        estado={venue_country}
                        opta_event_url={opta_event_url}
                        clase={item.class}
                        period_title={period_title}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
}